<div class="loading-screen-wrapper" *ngIf="(loading | async) === true">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-light" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
